var map = {
	"./arulananth.webp": 22350,
	"./dharshne.webp": 47453,
	"./jemimanilofar.webp": 57630,
	"./karthikeyan.webp": 41823,
	"./krishnamoorthy.webp": 77022,
	"./maheswari.webp": 36503,
	"./mohanasundari.webp": 85506,
	"./padmavathy.webp": 98241,
	"./prakash.webp": 71462,
	"./somasundaram.webp": 68183,
	"./sundharesalingam.webp": 4238,
	"./vaishnavi.webp": 47015,
	"./vetrivel.webp": 4805,
	"./vidhyapriya.webp": 47862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35664;